module.exports = __webpack_public_path__ + "static/img/heliheli.6f3acd4f.png";